import { jsx as _jsx } from "react/jsx-runtime";
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import Userback from "@userback/widget";
import { Header, Footer } from './App.static';
import APPSETTINGS from '@appsettings';
import { loadPunchlist } from './common/punchlist';
if (APPSETTINGS.USERBACK_KEY) {
    Userback(APPSETTINGS.USERBACK_KEY);
}
loadPunchlist();
createRoot(document.getElementById('site-header')).render(__DEV__ ? _jsx(StrictMode, { children: _jsx(Header, {}) }) : _jsx(Header, {}));
createRoot(document.getElementById('site-footer')).render(__DEV__ ? _jsx(StrictMode, { children: _jsx(Footer, {}) }) : _jsx(Footer, {}));
